import { render, staticRenderFns } from "./rp-read-index.vue?vue&type=template&id=02ec4c31&"
import script from "./rp-read-index.vue?vue&type=script&lang=js&"
export * from "./rp-read-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports